import { render, staticRenderFns } from "./DetailsBranding.vue?vue&type=template&id=3961196c&scoped=true&"
import script from "./DetailsBranding.vue?vue&type=script&lang=js&"
export * from "./DetailsBranding.vue?vue&type=script&lang=js&"
import style0 from "./DetailsBranding.vue?vue&type=style&index=0&id=3961196c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3961196c",
  null
  
)

export default component.exports